import React, { useState } from "react";
import "./PersonalInfo.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import CustomTimeSelector from "../../../../Components/CustomTimeSelector/CustomTimeSelector";
import CustomTable from "../../../../Components/CustomTable/CustomTable";
import CustomSwitch from "../../../../../Components/CustomSwitch/CustomSwitch";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const initialAddressData = [
  { tax_year: "2020", state_of_residence: "", from: "", to: "" },
  { tax_year: "2020", state_of_residence: "", from: "", to: "" },
  { tax_year: "2020", state_of_residence: "", from: "", to: "" },
  { tax_year: "2020", state_of_residence: "", from: "", to: "" },
];

const PersonalInfo = () => {
  const [addressData, setAddressData] = useState(initialAddressData);
  const columns = [
    {
      key: "tax_year",
      title: "Tax Year",
    },
    {
      key: "state_of_residence",
      title: "State of Residence",
      render: (row) => (
        <input
          type="text"
          className="cltdetails__personalinfo_cboxfield"
          style={{
            height: "45px",
            boxShadow: "0px 8px 16px 0px rgba(29, 66, 102, 0.06)",
            border: "1px solid rgba(255, 148, 122, 0.4)",
          }}
          placeholder="Enter State"
        />
      ),
    },
    {
      key: "from",
      title: "From",
      render: (row) => (
        <input
          type="date"
          className="cltdetails__personalinfo_cboxfield"
          style={{
            height: "45px",
            boxShadow: "0px 8px 16px 0px rgba(29, 66, 102, 0.06)",
            border: "1px solid rgba(255, 148, 122, 0.4)",
          }}
        />
      ),
    },
    {
      key: "to",
      title: "To",
      render: (row) => (
        <input
          type="date"
          className="cltdetails__personalinfo_cboxfield"
          style={{
            height: "45px",
            boxShadow: "0px 8px 16px 0px rgba(29, 66, 102, 0.06)",
            border: "1px solid rgba(255, 148, 122, 0.4)",
          }}
        />
      ),
    },
    {
      key: "options",
      title: "Options",
      render: (row) => (
        <div className="cltdetails__personalinfo_tableopts">
          <div className="cltdetails__personalinfo_tableoptplus">+</div>
          <div className="cltdetails__personalinfo_tableoptminus">-</div>
        </div>
      ),
    },
  ];
  return (
    <div className="cltdetails__personalinfo_page">
      <div className="cltdetails__personalinfo_contentwrap">
        <div className="cltdetails__personalinfo_contentbox">
          <div
            className="cltdetails__personalinfo_cboxheader"
            style={{ background: "rgba(5, 89, 91, 0.75)" }}
          >
            Personal Info
          </div>
          <div className="cltdetails__personalinfo_cboxbody">
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Filing Status{" "}
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["opt1"]}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Name{" "}
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter Name"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Occupation{" "}
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Ex. Businessman"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Email{" "}
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="email"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter Email"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Timezone
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["Central Standard Time(CST)"]}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    SSN
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="SSN"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Date of Birth
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="date"
                      className="cltdetails__personalinfo_cboxfield"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Date of Merriage
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="date"
                      className="cltdetails__personalinfo_cboxfield"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Visa Type
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["F1"]}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    First Date Entry of US{" "}
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="date"
                      className="cltdetails__personalinfo_cboxfield"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol"></div>
              <div className="cltdetails__personalinfo_cboxcol"></div>
            </div>
          </div>
        </div>
        <div className="cltdetails__personalinfo_contentbox">
          <div
            className="cltdetails__personalinfo_cboxheader"
            style={{ background: "rgba(12, 50, 185, 0.75)" }}
          >
            Contact Details
          </div>
          <div className="cltdetails__personalinfo_cboxbody">
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Phone Number
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter your number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Alternate No.
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter your number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Indian No.
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter your number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Mailing Address
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter Address"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Apartment
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="#"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    City
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter City Name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    State
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter State"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Zip
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter Zip Code"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol"></div>
            </div>
          </div>
        </div>
        <div
          className="cltdetails__personalinfo_contentbox"
          style={{ borderColor: "rgba(255, 148, 122, 0.4)" }}
        >
          <div
            className="cltdetails__personalinfo_cboxheader"
            style={{ background: "rgba(255, 148, 122, 1)", display: "flex" }}
          >
            <div className="cltdetails__personalinfo_cboxhheading">
              Address of Living tax year
            </div>
            <div className="cltdetails__personalinfo_cboxhdesc">
              <div>
                [Please list out all the address(es) you stayed at during the
                tax year]
              </div>
              <div>
                Please provide us the address/es where you lived in during the
                Tax Year, if you reside more the one state please add the boxes.
              </div>
            </div>
          </div>
          <div className="cltdetails__personalinfo_cboxbody">
            <CustomTable
              columns={columns}
              headerStyle={{
                backgroundColor: "rgba(233, 117, 89, 1)",
                minHeight: "64px",
              }}
              rowStyle={{
                backgroundColor: "transparent",
              }}
              data={addressData}
            />
            <br />
            <div
              className="cltdetails__personalinfo_checkboxitm"
              style={{ borderColor: "rgba(233, 117, 89, 0.3)" }}
            >
              <div className="cltdetails__personalinfo_cbileft">
                Have you worked with more than one employer in 2020?
              </div>
              <div className="cltdetails__personalinfo_cbiright">
                <span>YES</span>
                <CustomSwitch
                  onSwitch={() => {}}
                  color="rgba(233, 117, 89, 1)"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="cltdetails__personalinfo_contentbox">
          <div
            className="cltdetails__personalinfo_cboxheader"
            style={{ background: "rgba(12, 50, 185, 0.75)" }}
          >
            Spouse Details
          </div>
          <div className="cltdetails__personalinfo_cboxbody">
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Name
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Enter Name"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Date of Birth
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="date"
                      className="cltdetails__personalinfo_cboxfield"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Visa Type
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["F1"]}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__personalinfo_cboxrow">
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Entry Date into US (if any)
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="date"
                      className="cltdetails__personalinfo_cboxfield"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Occupation
                  </label>
                  <div className="cltdetails__personalinfo_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__personalinfo_cboxfield"
                      placeholder="Ex: Businessman"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__personalinfo_cboxcol">
                <div className="cltdetails__personalinfo_cboxfieldbox">
                  <label className="cltdetails__personalinfo_cboxfieldlbl">
                    Push Notification
                  </label>
                  <div className="cltdetails__personalinfo_radioswrap">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        value="ssn"
                        control={<Radio />}
                        label="SSN"
                      />
                      <FormControlLabel
                        value="itin"
                        control={<Radio />}
                        label="ITIN"
                      />
                      <FormControlLabel
                        value="applying_itin"
                        control={<Radio />}
                        label="Applying ITIN"
                      />
                      <FormControlLabel
                        value="renewing_itin"
                        control={<Radio />}
                        label="Renewing ITIN"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="cltdetails__personalinfo_checkboxitm">
              <div className="cltdetails__personalinfo_cbileft">
                Did your spouse worked in 2020?
              </div>
              <div className="cltdetails__personalinfo_cbiright">
                <span>YES</span>
                <CustomSwitch onSwitch={() => {}} />
              </div>
            </div>
          </div>
        </div>
        <div
          className="cltdetails__personalinfo_contentbox"
          style={{ borderColor: "rgba(255, 148, 122, 0.4)" }}
        >
          <div
            className="cltdetails__personalinfo_cboxheader"
            style={{ background: "rgba(255, 148, 122, 1)", display: "flex" }}
          >
            <div className="cltdetails__personalinfo_cboxhheading">
              Address of Living tax year
            </div>
            <div className="cltdetails__personalinfo_cboxhdesc">
              <div>
                [Please list out all the address(es) you stayed at during the
                tax year]
              </div>
              <div>
                Please provide us the address/es where you lived in during the
                Tax Year, if you reside more the one state please add the boxes.
              </div>
            </div>
          </div>
          <div className="cltdetails__personalinfo_cboxbody">
            <CustomTable
              columns={columns}
              headerStyle={{
                backgroundColor: "rgba(233, 117, 89, 1)",
                minHeight: "64px",
              }}
              rowStyle={{
                backgroundColor: "transparent",
              }}
              data={addressData}
            />
          </div>
        </div>
        <div
          className="cltdetails__personalinfo_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="cltdetails__personalinfo_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="cltdetails__personalinfo_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
      </div>
      <div className="cltdetails__personalinfo_contentwrap">
        <div className="cltdetails__personalinfo_bottombtns">
          <button className="cltdetails__personalinfo_bbtnfilled">
            Submit
          </button>
          <button className="cltdetails__personalinfo_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
